export default {
    computed: {
        csrfToken () {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        }
    }
};
